import * as React from "react";
import type { SVGProps } from "react";
const SvgDeleteThin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    fill="none"
    viewBox="0 0 21 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.417 5.833V4.167c0-.92.746-1.667 1.666-1.667h3.334c.92 0 1.666.746 1.666 1.667v1.666"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.167 5.832v10c0 .92-.747 1.667-1.667 1.667H7c-.92 0-1.667-.746-1.667-1.667v-10M3.667 5.835h14.166"
    />
  </svg>
);
export default SvgDeleteThin;
